<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('活动关联的商品.活动名称')" prop="huodongName">
                <a-input v-model="queryParam.huodongName" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('活动关联的商品.活动名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.昵称')" prop="nickName">
                <a-input v-model="queryParam.nickName" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('用户.昵称')" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.邮箱')" prop="email">
                <a-input v-model="queryParam.email" :placeholder="$t('通用.输入.请输入')+$t('用户.邮箱')" allow-clear/>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('系统用户.开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('系统用户.结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:log:export']">-->
<!--          <a-icon type="download" />{{$t('通用.按钮.导出')}}-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="multiple"  @click="handleSelectExport" v-hasPermi="['user:log:export']">-->
<!--          <a-icon type="download" />{{$t('通用.按钮.选中导出')}}-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="isZhongjiang" slot-scope="text, record">
            <span v-if="record.isZhongjiang === 1" style="color: #52c41a;">
            {{ $t('用户投票记录.已中奖') }}
          </span>
        </span>
        <template slot="huodongGoodsPicture" slot-scope="text, record">
          <div>
            <img v-if="record.huodongGoodsPicture" :src="record.huodongGoodsPicture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.huodongGoodsPicture)" alt="none"/>
          </div>
        </template>
        <template slot="score" slot-scope="text, record">
          <span v-if="editingId !== record.id" class="editable-score" @click="startEditScore(record)">
            {{ record.score }} <a-icon type="edit" style="font-size: 12px; color: #1890ff; margin-left: 4px;" />
          </span>
          <span v-else style="display: inline-flex; align-items: center;">
            <a-input-number
              v-model="editingScore"
              :min="0"
              :precision="0"
              size="small"
              style="width: 100px;"
              @pressEnter="confirmEditScore(record)"
            />
            <a-icon type="check" style="color: #52c41a; margin-left: 6px; cursor: pointer; font-size: 16px;" @click="confirmEditScore(record)" />
            <a-icon type="close" style="color: #ff4d4f; margin-left: 6px; cursor: pointer; font-size: 16px;" @click="cancelEditScore" />
          </span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-popconfirm :title="$t('通用.文本.确认删除所选中数据')" @confirm="handleDelete(record)">
            <a-button type="link" size="small" v-hasPermi="['zb:huodongsore:remove']">
              <a-icon type="delete" />{{$t('通用.按钮.删除')}}
            </a-button>
          </a-popconfirm>
        </template>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { huodongmingxi, editHuodongSore, delHuodongSore } from '@/api/user/log'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Log',
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 行内编辑积分
      editingId: null,
      editingScore: null,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: undefined,
        nickName: undefined,
        huodongName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        descr: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: this.getTableColumns(),
    }
  },
  filters: {
  },
  created () {
    this.getScoreRouteList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    $route:'getScoreRouteList',
    '$i18n.locale'() {
      // 语言变化时重新设置columns
      this.columns =  this.getTableColumns();
      this.getList();
    }

  },
  mounted() {

  },
  methods: {
    getTableColumns() {
      return [
        // {
        //   title: this.$t('用户积分变动记录.订单编号'),
        //   dataIndex: 'orderId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('用户.昵称'),
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.手机号'),
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户投票记录.活动名称'),
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('投票排行榜活动管理.活动开始时间'),
          dataIndex: 'startTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('投票排行榜活动管理.活动结束时间'),
          dataIndex: 'endTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户投票记录.积分'),
          dataIndex: 'score',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'score' }
        },
        {
          title: this.$t('通用.文本.创建时间'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          width: 120
        },
      ]
    },

    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },

    getScoreRouteList() {
      let params = this.$route.params;
      if (params.userId) {
        this.queryParam.userId = params.userId
      }
      this.getList()
    },

    /** 查询用户积分变动记录列表 */
    getList () {
      this.loading = true
      huodongmingxi(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        nickName: undefined,
        huodongName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        descr: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      let data = [row.id]
      return delHuodongSore(data)
        .then(() => {
          that.onSelectChange([], [])
          that.getList()
          that.$message.success(that.$t('通用.文本.删除成功'), 3)
        })
    },
    /** 行内编辑积分 - 开始 */
    startEditScore(record) {
      this.editingId = record.id
      this.editingScore = record.score
    },
    /** 行内编辑积分 - 取消 */
    cancelEditScore() {
      this.editingId = null
      this.editingScore = null
    },
    /** 行内编辑积分 - 确认 */
    confirmEditScore(record) {
      if (this.editingScore === null || this.editingScore === undefined) {
        this.$message.warning(this.$t('用户投票记录.积分') + '不能为空')
        return
      }
      var that = this
      let data = {
        id: record.id,
        huodongId: record.huodongId,
        userId: record.userId,
        score: that.editingScore
      }
      editHuodongSore(data).then(() => {
        that.$message.success(that.$t('通用.文本.修改成功'), 3)
        that.editingId = null
        that.editingScore = null
        that.getList()
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('user/log/export',
            that.queryParam
          , `用户积分变动记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出选中数据'),
        onOk () {
          that.download('user/log/export', queryParam, `用户积分变动记录_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>

<style scoped>
.editable-score {
  cursor: pointer;
}
.editable-score:hover {
  color: #1890ff;
}
</style>
